import { useEffect, useCallback } from "react";

const useOutsideClickHandler = (ref, onClose, isOpen) => {
  const handleClickOutside = useCallback(
    (e) => {
      if (ref.current.contains(e.target)) {
        return;
      }
      onClose();
    },
    [onClose, ref]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside, isOpen]);
};

export default useOutsideClickHandler;
